'use strict';

angular.module('bringgApp.directives').directive('alertsWidget', function () {
	return {
		restrict: 'E',
		replace: true,
		templateUrl: 'scripts/directives/alerts_widget/alerts-widget.html'
	};
});
